import React, { Component,useMemo, useEffect, useState } from 'react';
import { Helper } from '../../../src/ToolKit/toolkit.js';

import $ from 'jquery/dist/jquery';
import { Menu, ColumnType, Action, AlertD, YesNo, DropDownBox, SelectBasic, DayTimeSelector, FormDiv, InputBox, Icon, SideView, SideItem, FilterView, SpecValues, ProTable, SimpleButton, CustomHelper, FixedMessage, Captia, Column, NewRecordValue, FromBasic, AddButton, FileProgess, LoadingBar, FromSubmit, InputTextBox, InputPasswordBox, Model, Confirm, RowState, ShowFixedPage } from '../.././Componet';
import { useParams, useNavigate } from "react-router-dom";
import { Route, Link } from "react-router-dom";
import { Modal } from 'bootstrap';
import { DataClass, enums } from '../../../src/ToolKit/DataClass.js'
import { data, param } from 'jquery';
import { SerailBySerail } from '../ProductService/Pages.jsx';

const Cart = ({
    products = [],
    priceTitle = window.config.PriceTitle,
    onAddProduct,
    onRemoveProduct,
    onRemoveProductAll,
    onCheckout,methods
}) => {
    // -----------------------------
    // محاسبه اطلاعات سبد خرید
    // -----------------------------

    const totalItems = useMemo(() => {
        return products.reduce(
            (sum, product) => sum + product.inCart,
            0
        );
    }, [products]);

    const totalPrice = useMemo(() => {
        return products.reduce(
            (sum, product) =>
                sum + product.price * product.inCart,
            0
        );
    }, [products]);

    const totalDiscount = useMemo(() => {
        return products.reduce(
            (sum, product) =>
                sum + product.discount * product.inCart,
            0
        );
    }, [products]);

    const payableAmount = totalPrice - totalDiscount;

    // -----------------------------
    // فرمت قیمت
    // -----------------------------

    const formatPrice = (price) => {
        return new Intl.NumberFormat("fa-IR").format(price);
    };

    // -----------------------------
    // سبد خالی
    // -----------------------------

    if (!products.length) {
        return (
            <div className="container my-5" dir="rtl">
                <div className="card border-0 shadow-sm">
                    <div className="card-body text-center py-5">

                        <h2 className="h5 mb-3">
                            سبد خرید شما خالی است
                        </h2>

                        <a
                            href="/"
                            className="btn btn-purple px-4"
                        >
                            بازگشت به فروشگاه
                        </a>

                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container my-5" dir="rtl">

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">

                <h1 className="h4 fw-bold mb-0">
                    سبد خرید
                </h1>

                <span className="text-muted">
                    {formatPrice(totalItems)} کالا
                </span>

            </div>

            <div className="row g-4">

                {/* =========================
            لیست کالاها
        ========================== */}
                <div className="col-lg-8">

                    <div className="card border-0 shadow-sm">

                        <div className="card-header bg-white border-0 p-4">
                            <h2 className="h5 fw-bold mb-0">
                                کالاهای سبد خرید
                            </h2>
                        </div>

                        <div className="card-body p-4">

                            {products.map((product, index) => {

                                const productTotalPrice =
                                    product.price * product.inCart;

                                const productTotalDiscount =
                                    product.discount * product.inCart;

                                const productPayablePrice =
                                    productTotalPrice -
                                    productTotalDiscount;

                                const imageId =
                                    product.rootId == null
                                        ? product.productId
                                        : product.rootId;

                                return (
                                    <div
                                        key={product.productId}
                                        className={`
                      row
                      align-items-center
                      g-3
                      ${index !== products.length - 1
                                                ? "border-bottom pb-4 mb-4"
                                                : ""
                                            }
                    `}
                                    >

                                        {/* تصویر */}
                                        <div className="col-4 col-md-2 text-center">

                                            <img
                                                src={`/thm/Product_${imageId}.jpg`}
                                                alt={product.productName}
                                                className="cart-image img-fluid"
                                            />

                                        </div>

                                        {/* اطلاعات محصول */}
                                        <div className="col-8 col-md-5">

                                            <h3 className="h6 fw-bold mb-2">
                                                {product.productName}
                                            </h3>

                                            {product.discount > 0 && (
                                                <span className="badge bg-danger-subtle text-danger">
                                                    {formatPrice(product.discountPercent)}٪ تخفیف
                                                </span>
                                            )}

                                            <div className="mt-3">

                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        onRemoveProductAll?.(
                                                            product.productId, product.haveGranty
                                                        )
                                                    }
                                                    className="btn btn-sm btn-link text-danger p-0 text-decoration-none"
                                                >
                                                    حذف از سبد
                                                </button>

                                            </div>

                                        </div>

                                        {/* تعداد */}
                                        <div className="col-6 col-md-2 text-center">

                                            <div className="small text-muted mb-2">
                                                تعداد
                                            </div>

                                            <div className="quantity-box">

                                                <button
                                                    type="button"  
                                                    onClick={() =>
                                                        onAddProduct?.(
                                                            product.productId, product.haveGranty
                                                        )
                                                    }
                                                >
                                                    +
                                                </button>

                                                <span className="quantity-number">
                                                    {product.inCart}
                                                </span>

                                                <button
                                                    type="button"  
                                                    onClick={() =>
                                                        onRemoveProduct?.(
                                                            product.productId, product.haveGranty
                                                        )
                                                    }
                                                >
                                                    −
                                                </button>

                                            </div>

                                        </div>

                                        {/* قیمت */}
                                        <div className="col-6 col-md-3 text-md-end text-start">

                                            {product.discount > 0 && (
                                                <>
                                                    <div className="small text-muted text-decoration-line-through">

                                                        {formatPrice(productTotalPrice)}

                                                        {" "}

                                                        {priceTitle}

                                                    </div>

                                                    <div className="small text-success mb-1">

                                                        تخفیف:

                                                        {" "}

                                                        {formatPrice(productTotalDiscount)}

                                                        {" "}

                                                        {priceTitle}

                                                    </div>
                                                </>
                                            )}

                                            <div className="fw-bold text-primary">

                                                {formatPrice(productPayablePrice)}

                                                {" "}

                                                {priceTitle}

                                            </div>

                                        </div>

                                    </div>
                                );
                            })}

                        </div>
                    </div>

                </div>


                {/* =========================
            خلاصه فاکتور
        ========================== */}
                <div className="col-lg-4">

                    <div className="card border-0 shadow-sm cart-summary">

                        <div className="card-body p-4">

                            <h2 className="h5 fw-bold border-bottom pb-3 mb-4">
                                خلاصه فاکتور
                            </h2>

                            {/* تعداد */}
                            <div className="d-flex justify-content-between mb-3">

                                <span className="text-muted">
                                    تعداد کالاها
                                </span>

                                <span>
                                    {formatPrice(totalItems)} عدد
                                </span>

                            </div>

                            {/* مجموع */}
                            <div className="d-flex justify-content-between mb-3">

                                <span className="text-muted">
                                    مجموع قیمت کالاها
                                </span>

                                <span>
                                    {formatPrice(totalPrice)}

                                    {" "}

                                    {priceTitle}
                                </span>

                            </div>

                            {/* تخفیف */}
                            <div className="d-flex justify-content-between mb-3 text-success">

                                <span>
                                    مجموع تخفیف
                                </span>

                                <span>
                                    -

                                    {" "}

                                    {formatPrice(totalDiscount)}

                                    {" "}

                                    {priceTitle}
                                </span>

                            </div>

                            <hr />

                            {/* مبلغ نهایی */}
                            <div className="d-flex justify-content-between align-items-center mb-4">

                                <span className="fw-bold">
                                    مبلغ فاکتور
                                </span>

                                <span className="fw-bold text-primary fs-5">

                                    {formatPrice(payableAmount)}

                                    {" "}

                                    {priceTitle}

                                </span>
                  
                            </div>
                            <center>              انتخاب روش تحویل</center>
                            {methods.map((v) => {
                                return <div> <input value={v.id } name="devmethod" type="radio">


                                </input>
                                    {v.name} <br />
                                    <span style={{ fontSize:'14px' }}> {v.description}</span>
                                   <br/>
                                    <span style={{ fontSize: '12px' }}>  {formatPrice(v.cost)}

                                        {" "}

                                        {priceTitle}</span>
                                </div>

                            })}


                            <center>
                            <SimpleButton
                                type="button"
                                onClick={onCheckout}
                        
                                title="صدور فاکتور"
                            >
                             
                                </SimpleButton>
                            </center>

                        </div>

                    </div>

                </div>

            </div>
        </div>
    );
};




function AjaxStatus(props) {
    return <div id='AjaxStatus' style={{ position: 'fixed', left: '0px', bottom: '0px', display: 'none' }}>
        <LoadingBar /> {FixedMessage.PleaseWait}
    </div>

}
function SmsReportForMe() {


    const [pageState, setData] = useState({ records: [], isLoaded: false, grouped: [], filter: '', pageTemplate: [], templateId: -1 });


    const serach = () => {
        let h = new Helper();

        h.SaveState();
        h.Validate();
        if (h.isValidate() == false) {

            return;
        }
        let data = h.GetPostData();
        h.Ajax('ClientHub', 'SerachMyMessages', data, (data) => {
            setData({ records: data, isLoaded: true, filter: '', grouped: pageState.grouped, pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };

 






    return <FromBasic>




       
        <InputTextBox caption="از تاریخ" columnName="start" mustFill="yes" model="start" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
        <InputTextBox caption="تا تاریخ" columnName="end" mustFill="yes" model="end" size="50%" customHelper={CustomHelper.isDate}></InputTextBox>
        <center>
        </center>


        <center>
            <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>

        </center>

        {pageState.isLoaded &&
            <ProTable rowNumbering={true} datasourcename="records" key={Date().toString()} Records={pageState.records}>
                <Column metaForDisplay={DataClass.SmsReport.CreateTime} />
                <Column metaForDisplay={DataClass.SmsReport.Mobile} />
                <Column metaForDisplay={DataClass.SmsReport.Context} />
                <Column metaForDisplay={DataClass.SmsReport.ApplicationTitle} />
                <Column metaForDisplay={DataClass.SmsReport.Result} />
       
            </ProTable>


        }

    </FromBasic>

}


function MyOrders() {





    let status = useParams().status;
    const [pageState, orders] = useState({ orders: [], isLoaded: false, filter: '', pageTemplate: [], templateId: -1 });
 

    const serach = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('ClientHub', 'MyOrders', data, (data) => {
            orders({ orders: data, isLoaded: true, filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };
    


 

     
    

    const Print = (record) => {
        window.open('/sf/' + record.id );

    }
    const StartPay = (record) => {
        window.open('/po/' + record.id );

    }
    const GetDelevryInfo = (record) => {
        let h = new Helper();
        h.Ajax('ClientHub', 'GetOrderStatus', { id: record.id }, (data) => {
            h.MessageBox(('زمان :' + data.order.deleryTime + '<br/>' +
                'وضعیت :' + h.GetCaptionFromEnum(enums.DeleryStatus, data.order.deleryStatus) + '<br/>'
                + 'کد مرسوله :' + data.order.postCode + '<br/>'
                + 'کد اعمال محصول :' + data.order.code + '<br/>'
                + 'نحوه تحویل :' + h.GetCaptionFromEnum(enums.DelveryMethod, data.order.delveryMethod) + '<br/>'
                + 'تحویل گیرنده :' + data.order.delveryPerson + '<br/>'
            ).replace(/null/g,''), '')
        });
    };


   
    

    
 

     

   
 


    return <FromBasic>
        <form className="row g-3" id="serachBar"  >
               <InputTextBox caption="از تاریخ" columnName="StartDate" model="StartDate" size="33%" customHelper={CustomHelper.isDate}></InputTextBox>
            <InputTextBox caption="تا تاریخ" columnName="EndDate" model="EndDate" size="33%" customHelper={CustomHelper.isDate}></InputTextBox>
            <SelectBasic caption="وضعیت مالی" columnName="PayStatus" model="payStatus" includeAll={true} source={enums.PayStatus} size="33%" ></SelectBasic>
            <center>
                <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
            </center>
        </form>
      
     
        {pageState.isLoaded &&
            <ProTable rowNumbering={true} datasourcename="Orders" key={Date().toString()} Records={pageState.orders}>
         
                <Column metaForDisplay={DataClass.OrderSerachReport.OrderDate} />
                <Column metaForDisplay={DataClass.OrderSerachReport.TotalFactor} />
               
                <Column metaForDisplay={DataClass.OrderSerachReport.PayStatus} />

                <Column metaForDisplay={DataClass.OrderSerachReport.PayAmount} />
           
                <Column metaForDisplay={DataClass.OrderSerachReport.FactorState} />
                <Action caption="نسخه چاپی" Icon="Print" type="function" targetFun={Print} />
                <Action caption="پرداخت الکترونیک" Icon="Cash" type="function" targetFun={StartPay} />
                <Action caption="اطلاعات تحویل" Icon="Products" type="function" targetFun={GetDelevryInfo} />


            </ProTable>


        }

    </FromBasic>

}

function MyTransactions() {


    const [pageState, setData] = useState({ records: [], isLoaded: false, filter: '', pageTemplate: [], templateId: -1 });


    const serach = () => {
        let h = new Helper();
        h.SaveState();
        let data = h.GetPostData();
        h.Ajax('ClientHub', 'GetMyTransactions', data, (data) => {
            setData({ records: data, isLoaded: true, filter: '', pageTemplate: pageState.pageTemplate, templateId: pageState.templateId });

        });
    };



    return <FromBasic>


          <InputTextBox caption="از مبلغ" columnName="startAmount" model="startAmount" size="25%" customHelper={CustomHelper.isDigitngGroupedNumber}></InputTextBox>
        <InputTextBox caption="تا مبلغ" columnName="endAmount" model="endAmount" size="25%" customHelper={CustomHelper.isDigitngGroupedNumber}></InputTextBox>

        <InputTextBox caption="از تاریخ" columnName="StartDate" model="StartDate" size="25%" customHelper={CustomHelper.isDate}></InputTextBox>
        <InputTextBox caption="تا تاریخ" columnName="EndDate" model="EndDate" size="25%" customHelper={CustomHelper.isDate}></InputTextBox>
          <center>
            <SimpleButton onClick={serach} title="جست و جو " Icon="View"></SimpleButton>
        </center>

        {pageState.isLoaded &&
            <ProTable rowNumbering={true} datasourcename="records" key={Date().toString()} Records={pageState.records}>
                <Column metaForDisplay={DataClass.PaymentRef.PaymentRefId} />
                <Column metaForDisplay={DataClass.PaymentRef.ERefId} />
                <Column metaForDisplay={DataClass.PaymentRef.ObjectType} />
                <Column metaForDisplay={DataClass.PaymentRef.ObjectId} />
                <Column metaForDisplay={DataClass.PaymentRef.Amount} />
                <Column metaForDisplay={DataClass.PaymentRef.FullName} />
                <Column metaForDisplay={DataClass.PaymentRef.Mobile} />
                <Column metaForDisplay={DataClass.PaymentRef.Descr} />

                <Column metaForDisplay={DataClass.PaymentRef.CreateTime} />
                <Column metaForDisplay={DataClass.PaymentRef.SelfRefId} />
                <Column metaForDisplay={DataClass.PaymentRef.PaymentStatus} />
                <Column metaForDisplay={DataClass.PaymentRef.CardNo} />



            </ProTable>


        }

    </FromBasic>

}



export function RegUser(props) {

    const webotp = async () => {
        if (!('OTPCredential' in window)) {
            console.warn('WebOTP API is not supported in this browser.');
            return;
        }

        try {
            const abortController = new AbortController();

            const otp = await navigator.credentials.get({
                otp: { transport: ['sms'] },
                signal: abortController.signal
            });

            if (otp && otp.code) {
                const input = document.getElementById('txtVerfiyCode');
                if (input) {
                    input.value = otp.code;
                  
                }
            }
        } catch (error) {
            console.error('WebOTP error:', error);
        }
    };
 
    const mode = { InputMobile: 0, InputCode: 1 };
    const [pageState, loadState] = useState({ mode: mode.InputMobile,mobile:'' });
    const startLogin = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            h.Ajax('Home', 'LoginByMob', { mobileId: $('#txtMobileNo').val(), dontCreateUser:true }
                , (data) => {
                    if (data.status == 200) {

                        loadState({ mobile: $('#txtMobileNo').val(), mode: mode.InputCode });
                        webotp();
                    }
                    h.Error(data.message);
                }

            );
        }

    };
    const sendCode = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            h.Ajax('Home', 'LoginByPhone', { mobileNo: pageState.mobile, dynamicPassCode: $('#txtVerfiyCode').val() }
                , (data) => {
                    if (data.status == 200) {
                   
                      
                    }
                    if (data.token != "") {
                        localStorage.setItem('token', data.token);
                        window.location = "/Login";
                    }
                    else {
                        h.Error(data.message);
                    }
                   
                }

            );
        }


    };
    const Containr=(props = { title: '' }) => {
        return <div style={{ color: 'black' }}>

            <div style={{ position: 'fixed', color: 'black', background: 'url(/backgrounds/Bk.jpg)', backgroundSize: 'cover', left: '0px', top: '0px', zIndex: '-10', bottom: '0px', right: '0px' }} />
            <center>
                <div className="container">
                    <div className="row" style={{ padding: '25px' }}>
                        <center>
                            <div className="col-sm-8" style={{ backdropFilter: 'blur(5px)', fontSize: 'small', minWidth: '300px', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', background: '#ffffff57', borderRadius: '5px', boxShadow: '1px 1px 3px black' }} role="alert">

                                <FromBasic staticTitle={props.title} >
                                    <center> {props.children}</center>
                                </FromBasic>                   <Link to="/" id="Startup" ></Link>
                                <Link to="/Admin/Index.html" id="AdminPage" ></Link>
                               
                            </div>
                        </center>
                    </div>
                </div>




            </center>
            <Model />
            <Confirm />
            <AjaxStatus />
        </div>;

    }
    if (pageState.mode == mode.InputMobile) {
        if (localStorage.getItem('token') != null) {
            let hlp = new Helper();
            hlp.Ajax('Home', 'GetLoginInfo', {},
                function (data) {
                
                    if (data.logined == true) {
                        window.location = "/Admin/Index.html";
                    }
                    else {
                   
                        localStorage.clear();
                    }
                }, function (err) {
                
                    localStorage.clear();

                });
        }




        return <Containr title="ثبت نام کاربر جدید">
            <SideView>
                <SideItem title="قوانین" id="ruls">
                    <div style={{ maxHeight: '500px', overflowY: 'scroll' }}>  <ShowFixedPage id={"قوانین"} />  </div> 
                </SideItem>
                <SideItem title="ثبت نام" id="reg">
                    <div style={{ maxHeight: '500px', overflowY: 'scroll' }}>     <ShowFixedPage id={"ثبت نام اینترنتی"} /> </div>
                </SideItem>
            </SideView>
            <br />
           شما با ورود یا ثبت نام به سامانه با موارد قوانین این وبگاه موافقت کردید
            <InputBox meta={DataClass.User.MobileNo} size="50%" />
            <center>
                <SimpleButton title="ارسال پیامک" onClick={startLogin} ></SimpleButton>
                <SimpleButton title="بازگشت" onClick={() => { new Helper().GoBack(); }} > </SimpleButton>
            </center>
        </Containr>
    }
    if (pageState.mode == mode.InputCode) {
        return <Containr title="ثبت نام کاربر جدید">
            <InputBox meta={DataClass.MobileVerify.VerfiyCode} oneTimePassword={true} size="50%" />
            <center>
                <SimpleButton title="ورود" onClick={sendCode} ></SimpleButton>
                <SimpleButton title="تغییر شماره" onClick={() => {
                    loadState({ mobile: '', mode: mode.InputMobile });
                }} > </SimpleButton> 
            </center>
        </Containr>;
    }
    return <span>sad</span>;
}

export function Profile(props) {

    const [pageState, loadState] = useState({ isLoaded: false });
    const submit=()=>
    {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == true) {
            h.Ajax('ClientHub', 'SetProfile', h.GetPostData(),
                (data) => {
                    if (data.status == '200') {
                        h.GoBack();
                    }
                    h.MessageBox(data.message);
                }

            )
        }
    }
    const load = () => {
        let h = new Helper();
        h.Ajax('ClientHub', 'GetProfile', h.GetPostData(),
            (data) => {
                loadState({ isLoaded: true });
                h.SetDataBack(data);
            }

        )

    };
    if (pageState.isLoaded == false) {

        load();
        
    }

    return <FromSubmit submitBev={submit}>
    دقت نمائید نام و نام خانوادگی و کد ملی فقط یکبار قابل درج می باشد  
        <InputTextBox columnName="Name" caption="نام و نام خانوادگی" mustFill="yes" initvalue="name" model="Name" size="100%" />
        <InputBox meta={DataClass.Customer.NatCode} mustFill="yes" />
        <InputBox meta={DataClass.Customer.Address} mustFill="yes" />
        <InputBox meta={DataClass.Customer.PostCode} />
        <InputBox meta={DataClass.Customer.CityId} />
        <InputBox meta={DataClass.User.sex} />
    </FromSubmit>;

}

 
 

// ---------- دیتای نمونه ----------
 
const ProductList = (props) => {
    const [search, setSearch] = useState('');
    const [category, setCategory] = useState('');
    const [order, setOrder] = useState('newest');
    const [page, setPage] = useState(1);
    const [item, setItem] = useState({ products: [],totalCount:0 });
    const [categroy, setCateGory] = useState({ categroys: [] });
    const [fristLoad, fristLoadState] = useState({ loaded: false });
    // فعال‌سازی Select2 روی select دسته‌بندی
    useEffect(() => {
        $('#categorySelect').select2({
            placeholder: 'انتخاب دسته‌بندی…',
            allowClear: false,
            dir: 'rtl',
        }).on('change', (e) => {
            getLoad(1);
        });
        return () => {
            try {

                $('#categorySelect').select2('destroy');
            }
            catch
            {

            }
         
        }
    }, []);

    // فیلتر + مرتب‌سازی
    const filtered = item.products;

    const totalPages = Math.ceil(item.totalCount / 8);
    const pageItems = item.products;

    // ----- فرمت قیمت -----
    const fmtPrice = n => n.toLocaleString('fa-IR')  + ' ' + window.config.PriceTitle;

    const getLoad=(currentPage)=>
    {
        let h = new Helper();
        var data = h.GetPostData();
        data.currentPage = currentPage;
        h.Ajax('ClientHub', 'ProductSerach', data, (result) => {
            setItem({ products: result.items, totalCount: result.totalRecords });
            setPage(currentPage);
            loadCate();
        });
        

    }

    if (fristLoad.loaded == false) {
        getLoad(1);
         
        fristLoadState({ loaded: true });
       
        
    }
    const addToCart = (productId) => {
        if (props.anymos != undefined) {
            window.location = "/Admin/Shop";
        }
        let h = new Helper();
        h.Ajax('ClientHub', 'AddToCart', { productId: productId }, (data) => {
            h.Alert(data.message);
            getLoad(1);
        });
    }
    const loadCate = () => {
        let h = new Helper();
        h.Ajax('ClientHub', 'GetCategorys', {}, (result) => {
            setCateGory({ categroys: result });
        });

    };
    return (
        <form className="container-fluid py-4" dir="rtl">

            {/* ===== ردیف ۱: جستجو ===== */}
            <div className="row mb-3">
                <div className="col-12">
                    <div className="input-group input-group-lg shadow-sm">
                        <span className="input-group-text bg-white border-0">
                            <i className="bi bi-search"></i>  
                        </span>
                        <input model="title"
                            type="text"
                            className="form-control border-0"
                            placeholder="به دنبال چه می‌گردی؟"
                            
                            onKeyUp={e => { getLoad(1);  }}
                        />
                    </div>
                </div>
            </div>

            {/* ===== ردیف ۲: دسته‌بندی + ترتیب ===== */}
            <div className="row mb-4">
                {/* نصف سطر: دسته‌بندی (Select2) */}
                <div className="col-md-6 mb-2 mb-md-0">
                    <select onChange={() => {   getLoad(1); }} model="category" id="categorySelect" className="form-select">
                        <option value=""></option>
                        {categroy.categroys.map(c => <option key={c} value={c.id}>{c.name}</option>)}
                    </select>
                </div>
                {/* نصف سطر: ترتیب */}
                <div className="col-md-6">
                    <select
                        className="form-select"
                         model="order"
                        onChange={e => getLoad(1)}
                    >
                   
                        <option value="newest">جدیدترین</option>
                        <option value="oldest">جدیدترین</option>
                        <option value="cheapest">ارزان‌ترین</option>
                        <option value="expensive">گران‌ترین</option>
                    </select>
                </div>
            </div>

            {/* ===== ردیف محصولات: هر ردیف ۴ تا ===== */}
            <div className="row g-3">
                {pageItems.map(p => (
                    <div className="col-sm-6 col-lg-3" key={p.id}>
                        <div className="card h-100 shadow-sm border-0 product-card">
                            <img
                                src={'/thm/product_' + p.productId +".jpg"}
                                className="card-img-top"
                                alt={p.title}
                                style={{ objectFit: 'contain', height: 180 }}
                            />
                            <div className="card-body d-flex flex-column">
                                <h6 className="card-title text-truncate mb-2">{p.productName}</h6>
                                <p className="text-muted small mb-1">{p.cateGroyName}</p>
                                <div className="fw-bold text-primary mb-3">
                                    {p.haveGranty == true && <span style={{ borderRadius: '5px', position: 'absolute', right: '0px', top: '0px', padding: '10px', margin: '5px', background: 'linear-gradient(gold,#a1a704)', fontWeight: 'normal', boxShadow: '#ffd7004a 1px 1px 5px', color: 'white' }}>12 ماه ضمانت</span>}


                                    {p.discount == 0 && <span> {fmtPrice(p.price)} </span>}
                                    {p.discount != 0 && <span><span style={{ textDecoration: 'line-through', color: 'black' }}> {fmtPrice(p.price)}
                                     
                                    </span>
                                        <span style={{ borderRadius: '5px', position: 'absolute', left: '0px', top: '0px', padding: '10px', margin: '5px', background: 'linear-gradient(red,#ad1313)', boxShadow: 'pink 1px 1px 10px', fontWeight: 'normal', color: 'white' }}> {p.discountPercent}%</span>
                                  
                                        <br /> <span style={{ margin: '5px' }}>
                                             {fmtPrice(p.price - p.discount)}
                                        </span>
                                    </span>}
                                </div>

                                <div className="mt-auto d-grid gap-2">
                                    {props.anymos == undefined && < Link to={"/Admin/ShowProduct/" + p.productId} type="button" className="btn btn-outline-primary btn-sm">
                                        جزییات بیشتر
                                    </Link>}
                                    {props.anymos != undefined && < Link to={"/ShowProduct/" + p.productId} type="button" className="btn btn-outline-primary btn-sm">
                                        جزییات بیشتر
                                    </Link>}
                                    {p.haveChild == false && <span > در سبد شما :{p.inCart} <br /> </span> }
                                  


                                {p.canOrder == true && p.haveChild==false &&

                                        <button type="button" onClick={() => { addToCart(p.productId) }} className="btn btn-success btn-sm">
                                            🛒 افزودن به سبد خرید
                                        </button>
                                }
                                    {p.canOrder == true && p.haveChild == true &&
                                        <Link to={ (props.anymos == undefined?"/Admin":"") + "/ShowProduct/" + p.productId} >
                                    <button type="button"   className="btn btn-success btn-sm">
                                        🛒 افزودن به سبد خرید
                                        </button>
                                    </Link>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                {pageItems.length === 0 && (
                    <div className="col-12 text-center text-muted py-5">
                        هیچ محصولی یافت نشد 😕
                    </div>
                )}
            </div>

            {/* ===== صفحه‌بندی ===== */}
            {totalPages >= 1 && (
                <nav className="mt-4" dir="ltr">
                    <ul className="pagination justify-content-center">
                        <li className={`page-item ${page === 1 && 'disabled'}`}>
                            <button type="button" style={{ borderRadius: '0px' }} className="page-link" onClick={() => setPage(p => {
                                Math.max(1, p - 1);
                                getLoad(Math.max(1, p - 1));
                            })}>«</button>
                        </li>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(n => (
                            <li key={n} className={`page-item ${page === n && 'active'}`}>
                                <button type="button" className="page-link" onClick={() => { setPage(n); getLoad(n); }}>{n}</button>
                            </li>
                        ))}
                        <li className={`page-item ${page === totalPages && 'disabled'}`}>
                            <button type="button" style={{ borderRadius:'0px' }} className="page-link" onClick={() => {
                                setPage(p => {
                                    Math.min(totalPages, p + 1);
                                    getLoad(Math.min(totalPages, p + 1));
                                });
                              
                            }}>»</button>
                        </li>
                    </ul>
                </nav>
            )}
        </form>
    );
};

export default ProductList;


 
// فرض می‌کنیم useParams, useState, LoadingBar, FromBasic, FormDiv و Helper قبلاً ایمپورت شده‌اند

export function ShowProduct(props) {
    const id = useParams().id;
    const [pageState, loadState] = useState({ loaded: false, product: null });

    // استیت‌های جدید برای گالری تصاویر
    const [selectedImage, setSelectedImage] = useState(null);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [commentState, loadCommentState] = useState({ loaded: false, comments: [] });

    const fmtPrice = n => n.toLocaleString('fa-IR') + ' ' + window.config.PriceTitle;

    const load = () => {
        let h = new Helper();
        h.Ajax('ClientHub', 'GetProduct', { id: id }, (data) => {
            loadState({ loaded: true, product: data });
            window.filter = new Object();
            setTimeout(hideAll, 500);
        });
    };
    const hideAll = () => {
        var rows = document.querySelectorAll("tr[id]");
        for (let i = 0; i < rows.length; i++) {
            if (rows[i].id != 'none') {
                rows[i].style.display = 'none';
            }

        }
    }

    const loadComments = () => {
        let h = new Helper();
        h.Ajax('ClientHub', 'GetProductComments', { id: id }, (data) => {
            loadCommentState({ loaded: true, comments: data });
        });
    };
    const addToCart = (productId) => {
        if (props.anymos !== undefined) {
            window.location = "/Admin/Shop";
            return;
        }
        let grant = false;
        if ($('#txtGrant').length !== 0) {
            grant = $('#txtGrant')[0].checked;
        }

        let h = new Helper();
        h.Ajax('ClientHub', 'AddToCartGrantySelected', { productId: productId, needGranty: grant }, (data) => {
            h.Alert(data.message);
            load();
        });
    };

    if (pageState.loaded === false) {
        load();
        return <LoadingBar />;
    }
    if (commentState.loaded === false) {
        loadComments();
        
    }
    let product = pageState.product.items[0];

    function addFilter(cat, value) {
        let filter = window.filter;
        var buttons = document.querySelectorAll("[featid='" + cat + "']");

        for (let i = 0; i < buttons.length; i++) {
            buttons[i].style.background = '';
        }
        document.querySelectorAll("[value='" + value + "']")[0].style.background = 'black';
        filter[cat] = value;
        var rows = document.querySelectorAll("tr[id]");

        for (let i = 0; i < rows.length; i++) {
            if (rows[i].id == "NONE") {
                continue;
            }
            else {
                var mustShow = true;
                var keys = Object.keys(filter);
                for (let x = 0; x < keys.length; x++) {
                    let text = "[" + keys[x] + "=" + filter[keys[x]] + "]";
                    if (rows[i].id.indexOf(text) == -1) {
                        mustShow = false;
                    }
                }
                rows[i].style.display = mustShow ? "" : "none";

            }

        }



    }
  

    // آماده‌سازی آرایه تصاویر گالری (تصویر کاور به همراه گالری تصاویر در صورت وجود)
    const galleryImages = product.imageUrls;
    const allImages = [product.imageUrl, ...galleryImages].filter(Boolean);

    return (
        <FromBasic>
            {/* بخش گالری تصاویر به صورت کاشی و قطاری */}
            <FormDiv size="50%">
                   <center>
                        <img src={product.imageUrl} style={{ width: '60%'  }}></img>
                      </center>
                  </FormDiv>

            {/* بخش اطلاعات محصول */}
            <FormDiv size="50%">
                <h4 style={{ color: 'black' }}> نام محصول: {product.productName} </h4>
                گارانتی: {product.haveGranty === true && <span style={{ borderRadius: '5px', marginTop: '25px', background: 'linear-gradient(gold,#a1a704)', fontWeight: 'normal', boxShadow: '#ffd7004a 1px 1px 5px', color: 'white', padding: '2px 8px' }}>12 ماه ضمانت </span>}
                {product.haveGranty === false && <span>فاقد گارانتی</span>}
                <br />

                قیمت: {product.discount === 0 && <span> {fmtPrice(product.price)} </span>}
                {product.discount !== 0 && <span><span style={{ textDecoration: 'line-through', color: 'black' }}> {fmtPrice(product.price)}</span>
                    <br /> قیمت برای شما: <span style={{ borderRadius: '5px', margin: '5px', background: 'linear-gradient(red,#ad1313)', boxShadow: 'pink 1px 1px 10px', fontWeight: 'normal', color: 'white', padding: '2px 6px' }}> {product.discountPercent}%</span>
                    <span style={{ margin: '5px' }}>
                        {fmtPrice(product.price - product.discount)}
                    </span>
                </span>}
                <br />
                {product.haveGranty === true &&
                    <span> <input type="checkbox" id="txtGrant" defaultChecked /> ضمانت 12 ماه </span>
                }
                <br />
                {product.haveChild === false && <span> موجود در سبد شما: {product.inCart}<br /></span>}

                <FormDiv size="100%">
                    {product.descr}
                </FormDiv>
                {product.productFeats.map((feat) => <div>
                    {feat.record.displayName}<br/>
                    {feat.values.map((val) => <button type="button" featId={feat.record.id} value={val.id} onClick={() => { addFilter(feat.record.id, val.id) }} className="btn btn-success btn-sm">
                        {val.htmlContext == null && <span>{val.title}</span>}
                        {val.htmlContext != null && <span dangerouslySetInnerHTML={{ __html: val.htmlContext }}></span>  }
                    </button>)}
                    <br /><br/></div>)

                }



                {product.canOrder === true && product.haveChild === false &&
                    <button type="button" onClick={() => { addToCart(id); }} className="btn btn-success btn-sm">
                        🛒 افزودن به سبد خرید
                    </button>
                }
                {product.canOrder === true && product.haveChild === true &&
                    <span>
                        <table>
                            <tbody>
                                {product.subProducts.map((q) => (
                                    <tr key={q.id} id={q.tempId == null ? "none" : q.tempId}>
                                        <td>{q.productName}</td>
                                        <td>{fmtPrice(q.priceForYou)}</td>
                                        <td>
                                            {q.viewStatus === 2 && <button type="button"  onClick={() => { addToCart(q.id); }} className="btn btn-success btn-sm">
                                                🛒 افزودن به سبد خرید
                                            </button>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <br />
                    </span>
                }
                <h5 style={{ color: 'black' }}>نوع محصول: {product.cateGroyName} </h5>
            </FormDiv>
            <FormDiv size="100%">
                <div style={{ padding: '15px' }}>
                    <h6 style={{ color: '#666', marginBottom: '15px' }}>گالری تصاویر محصول:</h6>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
                        gap: '12px',
                        direction: 'rtl'
                    }}>
                        {allImages.map((imgUrl, index) => (
                            <div
                                key={index}
                                style={{
                                    position: 'relative',
                                    aspectRatio: '1/1',
                                    cursor: 'pointer',
                                    overflow: 'hidden',
                                    borderRadius: '12px',
                                    border: hoveredIndex === index ? '2px solid #a855f7' : '1px solid #ddd',
                                    boxShadow: hoveredIndex === index ? '0 0 10px rgba(168, 85, 247, 0.4)' : 'none',
                                    transition: 'all 0.3s ease',
                                }}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                onClick={() => setSelectedImage(imgUrl)}
                            >
                                <img
                                    src={imgUrl}
                                    alt={`${product.productName}-${index}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        transition: 'transform 0.4s ease',
                                        transform: hoveredIndex === index ? 'scale(1.08)' : 'scale(1)'
                                    }}
                                />
                                {/* لایه هاور با آیکون ذره‌بین */}
                                <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    opacity: hoveredIndex === index ? 1 : 0,
                                    transition: 'opacity 0.3s ease',
                                    fontSize: '1.2rem'
                                }}>
                                    <span>🔍</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </FormDiv>
            {/* بخش توضیحات طولانی */}
            <FormDiv size="100%">
                <span dangerouslySetInnerHTML={{ __html: product.longDescr }}></span>
            </FormDiv>

            {/* کامپوننت مدال لایت‌باکس تصاویر */}
            {selectedImage && (
                <div
                    onClick={(e) => e.target.id === 'img-modal-overlay' && setSelectedImage(null)}
                    id="img-modal-overlay"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        backdropFilter: 'blur(4px)'
                    }}
                >
                    <div style={{
                        position: 'relative',
                        backgroundColor: '#fff',
                        padding: '25px',
                        borderRadius: '16px',
                        maxWidth: '85%',
                        maxHeight: '85%',
                        boxShadow: '0 0 25px rgba(168, 85, 247, 0.5)',
                        textAlign: 'center'
                    }}>
                        {/* دکمه بستن */}
                        <button
                            onClick={() => setSelectedImage(null)}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: '#f43f5e',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '28px',
                                height: '28px',
                                cursor: 'pointer',
                                fontWeight: 'bold'
                            }}
                        >✕</button>

                        <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                            برای مشاهده تصویر اصلی در تب جدید، روی عکس کلیک کنید 🚀
                        </p>

                        {/* باز شدن در تب جدید با تگ A */}
                        <a href={selectedImage} target="_blank" rel="noreferrer">
                            <img
                                src={selectedImage}
                                alt="Full View"
                                style={{
                                    maxHeight: '70vh',
                                    maxWidth: '100%',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    border: '1px solid #eee'
                                }}
                            />
                        </a>
                    </div>
                </div>
            )}
            {commentState.loaded && 
                <ProductComments productId={id} key={new Date().toString()} initialReviews={commentState.comments} ></ProductComments>

            }
            

        </FromBasic>
    );
}



////export function ShowProduct(props) {
////    const id = useParams().id;
////    const [pageState, loadState] = useState({ loaded: false, product: null });
////    const fmtPrice = n => n.toLocaleString('fa-IR') + ' ریال';
////    const load = () => {
////        let h = new Helper();
////        h.Ajax('ClientHub', 'GetProduct', { id: id }, (data) => {
////            loadState({ loaded: true, product:data });
////        });

////    };
  
////    const addToCart = (productId) => {
////        if (props.anymos != undefined) {
////            window.location = "/Admin/Shop";
////        }
////        let grant = false;
////        if ($('#txtGrant').length != 0) {
////            grant = $('#txtGrant')[0].checked;
////        }
        

////        let h = new Helper();
////        h.Ajax('ClientHub', 'AddToCartGrantySelected', { productId: productId, needGranty: grant }, (data) => {
////            h.Alert(data.message);
////            load();
////        });
////    }


////    if (pageState.loaded == false) {

////        load();
       
////        return <LoadingBar />
////    }
////    let product = pageState.product.items[0];
    
////    return <FromBasic>
////        <FormDiv size="50%">
////         <center>
////             <img src={product.imageUrl} style={{ width: '60%'  }}></img> 
////            </center>
////        </FormDiv>
////        <FormDiv size="50%">
        
////            <h4 style={{ color: 'black' }}> نام محصول: {product.productName} </h4>
////            گارانتی: {product.haveGranty == true && <span style={{ borderRadius: '5px',   marginTop: '25px', background: 'linear-gradient(gold,#a1a704)', fontWeight: 'normal', boxShadow: '#ffd7004a 1px 1px 5px', color: 'white' }}>12 ماه ضمانت </span>}
////            {product.haveGranty == false &&  <span>فاقد گارانتی</span>}
////            <br />
       
////            قیمت :{product.discount == 0 && <span> {fmtPrice(product.price)} </span>}
////            {product.discount != 0 && <span><span style={{ textDecoration: 'line-through', color: 'black' }}> {fmtPrice(product.price)}

////            </span>
////                <br />   قیمت برای شما : <span style={{ borderRadius: '5px',     margin: '5px', background: 'linear-gradient(red,#ad1313)', boxShadow: 'pink 1px 1px 10px', fontWeight: 'normal', color: 'white' }}> {product.discountPercent}%</span>

////                 <span style={{ margin: '5px' }}>
////                    {fmtPrice(product.price - product.discount)}
////                </span>
////            </span>}
////            <br />
////            {product.haveGranty == true &&
////                <span> <input type="checkbox" id="txtGrant" defaultChecked />ضمانت 12 ماه  </span>  
////            }
////            <br />
////            {product.haveChild==false && <span> موجود در سبد شما : {product.inCart}<br /></span>
////            }
////            <FormDiv size="100%">
////                {product.descr}
////            </FormDiv>


////            {product.canOrder == true && product.haveChild == false  &&
////                <button type="button" onClick={() => { addToCart(id); }} className="btn btn-success btn-sm">
////                    🛒 افزودن به سبد خرید
////                </button>
////            }
////            {product.canOrder == true && product.haveChild == true &&
////                <span>
////                    <table>
////                        {product.subProducts.map((q) => {
////                            return <tr>
////                                <td>{q.productName}</td>
////                                <td>{fmtPrice(q.price)}</td>
////                                <td>
////                                    {q.viewStatus == 2 && <button type="button" onClick={() => { addToCart(q.id); }} className="btn btn-success btn-sm">
////                                        🛒 افزودن به سبد خرید
////                                    </button>
////                                    }

////                                </td>
////                            </tr>

////                        })}
////                    </table>

////                <br/>
////                </span>
////            }
////            <h5 style={{ color: 'black' }}>نوع محصول: {product.cateGroyName} </h5>
////        </FormDiv>
////        <FormDiv size="100%">
////            <span dangerouslySetInnerHTML={{ __html: product.longDescr }}></span>

////        </FormDiv>


////    </FromBasic>

////}

const MyCart = () => {
    const [search, setSearch] = useState('');
    const [category, setCategory] = useState('');
    const [order, setOrder] = useState('newest');
    const [page, setPage] = useState(1);
    const [item, setItem] = useState({ products: [], totalCount: 0 });
    const [categroy, setCateGory] = useState({ categroys: [] });
    const [fristLoad, fristLoadState] = useState({ loaded: false });
    const [delMethodInfo, setdelMethodInfo] = useState({ data:[] });
    // فعال‌سازی Select2 روی select دسته‌بندی
    useEffect(() => {
        $('#categorySelect').select2({
            placeholder: 'انتخاب دسته‌بندی…',
            allowClear: false,
            dir: 'rtl',
        }).on('change', (e) => {
            getLoad(1);
        });
        return () => $('#categorySelect').select2('destroy');
    }, []);

    // فیلتر + مرتب‌سازی
    const filtered = item.products;

    const totalPages = Math.ceil(item.totalCount / 8);
    const pageItems = item.products;

    // ----- فرمت قیمت -----
    const fmtPrice = n => n.toLocaleString('fa-IR') + ' ' + window.config.PriceTitle;

    const getLoad = (currentPage) => {
        let h = new Helper();
        var data = h.GetPostData();
        data.currentPage = currentPage;
        h.Ajax('ClientHub', 'MyCart', data, (result) => {
            setItem({ products: result.items, totalCount: result.totalRecords });
            setPage(currentPage);
           
        });
        h.Ajax('ClientHub', 'GetAllDevMethod', data, (result) => {
            setdelMethodInfo({ data: result });
            setPage(currentPage);

        });

    }
    const addToCartAuto = (productId) => {
        let h = new Helper();
        h.Ajax('ClientHub', 'AddToCartAutoBatch', { productId: productId }, (data) => {
            h.Alert(data.message);
            getLoad();
        });
    }
    if (fristLoad.loaded == false) {
        getLoad(1);

        fristLoadState({ loaded: true });
        if (sessionStorage.productId != undefined) {
            addToCartAuto(sessionStorage.productId);
            sessionStorage.clear();
        }

    }
    const addToCart = (productId,needGranty) => {
        let h = new Helper();
        h.Ajax('ClientHub', 'AddToCartGrantySelected', { productId: productId, needGranty: needGranty }, (data) => {
            h.Alert(data.message);
            getLoad();
        });
    }
   
    const removeCart = (productId, needGranty) => {
        let h = new Helper();
        h.Ajax('ClientHub', 'RemoveToCartGrantySelected', { productId: productId, needGranty: needGranty }, (data) => {
            h.Alert(data.message);
            getLoad();
        });
    }

    const removeCartAll = (productId, needGranty) => {
        let h = new Helper();
        h.Ajax('ClientHub', 'RemoveToCartGrantySelectedAll', { productId: productId, needGranty: needGranty }, (data) => {
            h.Alert(data.message);
            getLoad();
        });
    }


    const clearCart = () => {
        let h = new Helper();
        h.Ajax('ClientHub', 'ClearCart', {}, (data) => {
            h.Alert(data.message);
            getLoad();
        });
    }
    const CreateOrder = () => {
        let h = new Helper();
        h.Validate();
        if (h.isValidate() == false) {
            return;
        }
        var mehtod = document.querySelector('input[name="devmethod"]:checked')?.value;
     
        if (mehtod == undefined) {
            h.Alert("لطفا یک روش ارسال را انتخاب کنید");
            return;
        }

        h.Ajax('ClientHub', 'CreateOrder', { DevMethodId: mehtod }, (data) => {
            h.Alert(data.message);
            if (data.refId != undefined) {
                window.open("/sf/" + data.refId);
            }
            getLoad();
        });
    }


    return (
        <form className="container-fluid py-4" dir="rtl">
            <center>
                
                <SimpleButton onClick={() => { clearCart(); }} title="پاکسازی سبد خرید"></SimpleButton>
                <Link to="/Admin/Profile"> <SimpleButton onClick={() => {  }} title="تکمیل اطلاعات هویتی"></SimpleButton>
                </Link>
            </center>
            <Cart products={item.products} methods={delMethodInfo.data} onRemoveProductAll={removeCartAll} onCheckout={CreateOrder} onAddProduct={addToCart} onRemoveProduct={removeCart} />
             
        </form>
    );
};


export class MyLoans extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = ({ isLoaded: false, Records: [] });

        this.Refersh = this.Refersh.bind(this);

    }



    Refersh() {
        let cmd = this;
        let h = new Helper();
        h.Ajax('ClientHub', 'MyLoan', {}, function (data) {
            cmd.setState({ isLoaded: true, Records: data });
        });
    }

    componentDidMount() {
        this.Refersh();
    }
  
    render() {
        if (this.state.isLoaded == false) {
            return LoadingBar();

        }
        else {
            return <FromBasic staticTitle=''>
                <AddButton title='' entity='LoanInComingDateResult' /> <ProTable Records={this.state.Records} datasourcename='LoanInComingDateResults'>
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.id} />
                    
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.OrderId} />
                     
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.InComingDate} />
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.PayStatus} />
                    <Column metaForDisplay={DataClass.LoanInComingDateResult.Price} />
                    <Action caption="نمایش فاکتور" type="function" targetFun={(r) => {
                        window.open("/sf/" + r.orderId);
                    }} />
                    <Action caption="پرداخت" type="function" showCond={(r) => { return r.payStatus ==0 } } targetFun={(r) => {
                        window.open("/pl/" + r.id);
                    }} />




                </ProTable>
            </FromBasic>
        }
    }



}

export function MyUsagedAccounts(props) {

    const [pageState, loadState] = useState({ records: [] ,isLoaded:false});

    const serach = () => {
        let h = new Helper();
        let d = h.GetPostData();
        h.Ajax('ClientHub', 'MyGamingAccounts', d, (data) => {
            loadState({ records: data, isLoaded:true });
        });

    };
    if (pageState.isLoaded == false) {

        serach();
        return <LoadingBar />;
    }
 



    return <FromBasic static="اکانت های در اختیار من">

    
    
        <ProTable Records={pageState.records} datasourcename='UsageAccs'>
            <Column type={ColumnType.Image} caption="تصویر" columnName="gameId" url="/images/cover/" ext=".jpg" />
            <Column type={ColumnType.DisplayValue} caption="نام بازی" columnName="gameTitle" />
            <Column type={ColumnType.DisplayValue} caption="اکانت" columnName="email" />
            <Column metaForDisplay={DataClass.UsageAcc.usageType} />
            <Column metaForDisplay={DataClass.UsageAcc.delvere} />
            <Column metaForDisplay={DataClass.UsageAcc.descr} />
        

        </ProTable>
        <ShowFixedPage id={"قوانین ظرفیت ها"} />
    </FromBasic>
}

class UploadID extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { image: '/Icons/Doctor.png' };
        this.save = this.save.bind(this);
    }
    save() {
        let h = new Helper();
        let cmd = this;
        h.Validate();
        let formData = new FormData();
        let cx = document.getElementById('txtfil')
        formData.append('file', cx.files[0], cx.value);
        if (h.isValidate() == true) {
            h.AjaxForUpload('ClientHub', 'UploadId', formData, function (data) {
                h.MessageBox(data.message, '');
                if (data.status == '200') {
                    h.GoBack();
                }
            });
        }
    }
    componentDidMount() {
        let h = new Helper();
        let cmd = this;
        h.Ajax('ClientHub', 'GetIdPaper', {},
            function (data) {
                cmd.setState({ image: data.imgSrc });
            });
    }


    render() {
        return <FromSubmit submitBev={this.save}>
            <FormDiv size='100%' >
                تصویر فعلی <br></br>
                <img alt="تصویری ارسال نشده است" style={{ maxWidth:'100%' }} src={this.state.image + '?qid=' + Math.random().toString()}></img>
                <InputTextBox columnName='fil' caption='فایل' mustFill='yes' model='file' size='100%' customHelper={CustomHelper.File} ></InputTextBox>
            </FormDiv>

        </FromSubmit>
    }
}


export class Regit extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            level: 0, planId: 0, conso: 0, plans: [], game: [], prices: [], selectedPrice: {}, priceIndex: -1
        };

    }
    componentDidMount() {
        this.loadData();
    }
    loadData() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllPlan', {}, (data) => {
            s.plans = data;
            cmd.setState(s);

        });
    }
    loadGames() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllGameOfPlan', { id: this.state.planId }, (data) => {
            s.game = data;
            cmd.setState(s);

        });
    }
    loadPrice() {
        let s = this.state;
        let h = new Helper();
        let cmd = this;
        h = h.Ajax('Home', 'AllPriceOfPlan', { planTitle: '', planId: this.state.planId, console: this.state.conso }, (data) => {
            s.prices = data;
            cmd.setState(s);

        });
    }
    selectConsole(conType) {
        let s = this.state;
        s.level += 1;
        s.conso = conType;
        this.setState(s);
    }
    reg() {
        let h = new Helper();
        h.Validate();
        if (this.state.selectedPrice == null) {
            h.errors.push("لطفا یک گزینه برای طرح انتخاب کنید");
        }
        if (h.isValidate() == false) {
            return;
        }
        let data = h.GetPostData();
        var keys = Object.keys(this.state.selectedPrice);
        for (var l = 0; l < keys.length; l++) {
            data[keys[l]] = this.state.selectedPrice[keys[l]];
        }
        let cmd = this;
        let paymethod = data.payMethod;
        h.Ajax('ClientHub', 'RegGameSub', data, (data) => {
            if (data.status == '200') {
                h.Alert(data.message);
                let s = cmd.state;
                if (paymethod == '2') {
                    window.open("/sp/" + data.refId);
                }
                s.level = 3;
                cmd.setState(s);
            }
            else {
                h.Error(data.message);
            }
        });
    }
    render() {
        let h = new Helper();
        return <FromBasic staticTitle='ثبت نام' >



            {this.state.level == 0 &&
                <span>

                    لطفا نوع دستگاه خود را انتخاب کنید <br />
                    <button className="col-sm-12 btn" type="button" onClick={() => { this.selectConsole(0); }} style={{ border: '1px solid ', borderRadius: '5px' }}>
                        <img src="/images/ps4.jpg" height="80px"></img>
                        <br />
                        پلی استیشن 4
                    </button>
                    <button className="col-sm-12  btn" type="button" onClick={() => { this.selectConsole(1); }} style={{ border: '1px solid ', borderRadius: '5px' }}>
                        <img src="/images/ps5.jpg" height="80px"></img>
                        <br />
                        پلی استیشن 5
                    </button>
                </span>
            }
            {this.state.level == 1 &&
                <span>

                    لطفا نوع طرح را انتخاب کنید <br />

                    <br />
                    {this.state.plans.map((v) => {
                        return <span> <SimpleButton Icon={v.id == this.state.planId ? "Yes" : undefined} title={v.title} onClick={() => {
                            let s = this.state;
                            s.planId = v.id;
                            s.planTitle = v.title;
                            this.setState(s);
                            this.loadGames();
                        }}  ></SimpleButton>
                            <br />
                        </span>

                    })}


                    <center>
                        <button className="btn btn-light" type="button" onClick={() => { if (this.state.planId <= 0) { h.Alert("لطفا یک طرح انتخاب کنید"); } let s = this.state; s.level = 2; this.setState(s); this.loadPrice(); }}>
                            ادامه
                        </button>
                        <button className="btn btn-light" type="button" onClick={() => { let s = this.state; s.level = 0; this.setState(s); }}>
                            بازگشت
                        </button>
                        <FromBasic>
                            {this.state.game.map((v) => {
                                return <div className="col-sm-6">
                                    {v.title} <br />
                                    <img width="80px" src={"/images/cover/" + v.id + ".jpg"} ></img>

                                </div>
                            })}
                        </FromBasic>
                    </center>
                </span>
            }
            {this.state.level == 2 &&
                <span style={{ textAlign: 'right' }}>

                    لطفا مشخصات زیر پر کنید <br />

                    <br />
                    نوع دستگاه : {h.GetCaptionFromEnum(enums.GameType, this.state.conso)} طرح انتخابی : {this.state.planTitle}
                    <br />
                    {this.state.prices.map((v) => {
                        return <span> <SimpleButton Icon={v == this.state.selectedPrice ? "Yes" : undefined} title={h.GetCaptionFromEnum(enums.TimeDurrion, v.timeDurrion) + " تعداد بازی همزمان  " + v.gameCount} onClick={() => {
                            let s = this.state;
                            s.selectedPrice = v;
                            this.setState(s);
                        }}  ></SimpleButton>
                            <br />
                        </span>
                    })}

                      <InputBox meta={DataClass.Reg.payMethod} size="100%" />
               
                    <h2>
                        مبلغ قابل پرداخت: {h.addCommas(this.state.selectedPrice.price)} {window.config.PriceTitle}</h2> <br />
                    شماره کارت جهت پرداخت :6104337961803788 علی حسینی پور
                    <center>
                        <button className="btn btn-light" type="button" onClick={() => { this.reg() }}>
                            ثبت نام
                        </button>
                        <button className="btn btn-light" type="button" onClick={() => { let s = this.state; s.level = 0; this.setState(s); }}>
                            بازگشت
                        </button>

                    </center>
                </span>
            }
            {this.state.level == 3 &&
                <span>
                    ثبت نام شما با موفقیت انجام شد جهت ادامه به فروشگاه مراجعه کنید
                    <br />
                    <Link to="/Login">
                        بازگشت

                    </Link>


                </span>
            }
        </FromBasic>;
                
    }
}


const ProductComments = ({ productId, initialReviews = [] }) => {

    const alert = (txt) => {
        let h = new Helper();
        h.Alert(txt);


    };


    const submitCommentAjax = (productId) => {
        var rateInput = selectedRate;
        var commentText = document.getElementById('txtComment');
        let token = localStorage.getItem('token');
        var rate = (window.rate == undefined ? 0 : window.rate);
        var text = commentText ? commentText.value.trim() : "";

        if (rate === 0) {
            alert('لطفاً امتیاز بدهید ⭐');
            return;
        }
        if (text.length < 5) {
            alert('متن نظر خیلی کوتاه است');
            return;
        }
        
        fetch('/ClientHub/AddProductReview', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
            body: JSON.stringify({
                productId: productId,
                rate: rate,
                text: text
            })
        })
            .then(function (res) {
                if (res.status === 401) {
                    unauthorizedCallback();
                    return null;
                }

                return res.json();
            })
            .then(function (data) {





                if (data.status == 200) {
                    alert('نظر شما با موفقیت ثبت شد ✅');
                    commentText.value = '';
                    rateInput.value = '0';
                    document.querySelectorAll('#rateInput .star-input').forEach(function (s) {
                        s.classList.remove('active');
                    });
                } else {
                    alert(data.message || 'خطایی رخ داد');
                }
            })
            .catch(function (ex) {

                alert('خطا در ارتباط با سرور');
            });
    };

    const unauthorizedCallback = () => {


        // مثلاً نمایش پیام لاگین
        alert('برای ثبت نظر باید وارد حساب کاربری شوید.');
        sessionStorage.setItem("directUrl", window.location.pathname);



        
        // یا اجرای تابع موجود خودت
        // openLoginModal();

        // یا انتقال به صفحه ورود
        // window.location.href = '/Login';
    };





    const [reviews, setReviews] = useState(initialReviews);
    const [selectedRate, setSelectedRate] = useState(0);
    const [commentText, setCommentText] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const stats = useMemo(() => {
        const count = reviews.length;
        const avg = count > 0 ? reviews.reduce((acc, curr) => acc + curr.rate, 0) / count : 0;
        const distribution = [5, 4, 3, 2, 1].map(level => {
            const countAtLevel = reviews.filter(r => Math.round(r.rate) === level).length;
            const percent = count > 0 ? (countAtLevel * 100) / count : 0;
            return { level, countAtLevel, percent };
        });
        return { count, avg: avg.toFixed(1), distribution };
    }, [reviews]);
    const send=()=>
    {
        submitComment(productId);
    }
    const submitComment = () => {
        if (selectedRate === 0 || !commentText.trim()) return alert("لطفا اطلاعات را بررسی کنید مجددا ارسال کنید");
        setIsSubmitting(true);
        // اینجا منطق API رو اضافه کن

        submitCommentAjax(productId);
        // setReviews([{ userTitle: "کاربر مهمان", rate: selectedRate, comment: commentText, createTime: new Date() }, ...reviews]);
        setCommentText(''); setSelectedRate(0); setIsSubmitting(false);
        window.rate = 0;
    };

    return (
        <div className="glass-panel mt-4 p-4" id="commentsSection">
            <h3 className="product-title mb-4"><strong>نظرات کاربران</strong></h3>

            {/* خلاصه امتیاز */}
            <div className="row g-3 align-items-center mb-4">
                <div className="col-md-4 text-center">
                    <div style={{ fontSize: '42px', fontWeight: 'bold', color: '#a855f7' }}>{stats.avg}</div>
                    <div style={{ fontSize: '24px', color: '#ffc107' }}>
                        {[1, 2, 3, 4, 5].map(s => (
                            <span key={s} style={{ opacity: s <= Math.round(stats.avg) ? 1 : 0.3 }}>★</span>
                        ))}
                    </div>
                    <div className="text-muted-custom mt-1">از مجموع {stats.count} نظر</div>
                </div>

                <div className="col-md-8">
                    {stats.distribution.map(d => (
                        <div key={d.level} className="d-flex align-items-center gap-2 mb-1">
                            <span style={{ width: '60px', fontSize: '13px' }}>{d.level} ستاره</span>
                            <div className="progress flex-grow-1" style={{ height: '8px', background: '#2a2a3a', borderRadius: '4px' }}>
                                <div className="progress-bar" style={{ width: `${d.percent}%`, background: 'linear-gradient(90deg,#a855f7,#e11d48)' }}></div>
                            </div>
                            <span style={{ width: '35px', fontSize: '12px', color: '#aaa' }}>{d.countAtLevel}</span>
                        </div>
                    ))}
                </div>
            </div>

            <hr className="border-secondary my-3" />

            {/* لیست نظرات */}
            <div id="commentsList" className="mb-4">
                {reviews.length > 0 ? reviews.map((cmt, i) => (
                    <div key={i} className="comment-item glass-panel p-3 mb-3">
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <strong className="">{cmt.userTitle}</strong>
                                <div style={{ color: '#ffc107', fontSize: '16px' }}>
                                    {[1, 2, 3, 4, 5].map(s => (
                                        <span key={s} style={{ opacity: s <= Math.round(cmt.rate) ? 1 : 0.3 }}>★</span>
                                    ))}
                                </div>
                            </div>
                            <small className="text-muted-custom">{cmt.timeDesc}</small>
                        </div>
                        <p className="mt-2 mb-0 ">{cmt.comment}</p>
                    </div>
                )) : <p className="text-muted-custom text-center py-4">هنوز نظری ثبت نشده. اولین نفر باشید! ⭐</p>}
            </div>

            {/* فرم ارسال */}
            <div className="glass-panel p-4" id="commentFormWrap">
                <h5 className="product-title mb-3"><strong>ثبت نظر شما</strong></h5>
                <div className="mb-3">
                    <label className="form-label  ">امتیاز شما</label>
                    <div style={{ fontSize: '32px', cursor: 'pointer', color: '#ffc107' }}>
                        {[1, 2, 3, 4, 5].map(val => (
                            <span key={val}
                                style={{ opacity: selectedRate >= val ? 1 : 0.3 }}
                                onClick={() => {
                                    setSelectedRate(val)
                                    window.rate = val;
                                }}>★</span>
                        ))}
                    </div>
                </div>
                <textarea id="txtComment" className="form-control mb-3" rows="4"
                    placeholder="تجربه خودتون از این محصول رو بنویسید..."
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}></textarea>
                <SimpleButton onClick={submitComment}   disabled={isSubmitting} title="ارسال نظر" >
                  
                </SimpleButton>
            </div>
        </div>
    );
};



export function ClientHubApp(props) {

    let routes = [
        <Route path="MyMessages" element={<SmsReportForMe />} />,
        <Route path="MyOrders" element={<MyOrders />} />,
        <Route path="MyCart" element={<MyCart />} />,
        <Route path="SendId" element={<UploadID />} />,
        <Route path="RegGameSub" element={<Regit />} />,
        <Route path="MyAccounts" element={<MyUsagedAccounts />} />,
        <Route path="Shop" element={<ProductList />} />,
        <Route path="ShowProduct/:id" element={<ShowProduct />} />,
        <Route path="Profile" element={<Profile />} />,
        <Route path="MyLoans" element={<MyLoans />} />,
        <Route path="MyTransactions" element={<MyTransactions />} />,
        <Route path="GrantyStatus" element={<SerailBySerail />} />,
    ];
    return routes;
}